<template>
  <!-- 二次供水报警 -->
  <div class="mainWarp">
    <div class="img-title" @click="Rowclicklu">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">二次供水报警</span>
    </div>
    <div class="dataWarp" id="dataWarpt" @scroll.prevent>
      <div class="ulDiv" id="ulDivt" @scroll.prevent>
        <div class="dataItem" @scroll.prevent
          :class="{ dataItemNormal: item.alarmLevel == '预警', dataItemWarning: item.alarmLevel == '报警' }"
          v-for="(item, index) in dataList" :key="index" @click="showmodel(dataList[index])">
          <span class="dataItemTitle" :style="[item.alarmLevel == '报警' ? { color: '#FF3636' } : { color: '#ffcc66' }]">
            <span>{{ item.msgAddress }}</span><span>{{ item.flowMeterNo }}</span><span>{{ item.alarmIndex
            }}</span><span>{{ item.alarmType }}</span>
          </span>
          <span class="dataItemTime"
            :style="[item.alarmLevel == '报警' ? { color: 'rgba(255,54,54,0.75' } : { color: '#ffcc66' }]">{{
              item.updateTime }}</span>
        </div>
      </div>
      <div id="ulDiv2t"></div>
    </div>
    <a-modal :title="Title" :visible="visible" :footer="null" :bodyStyle="bodyStyle" @cancel="handleCancel">
      <p :style="[modelInfo.alarmLevel == '报警' ? { color: 'rgba(255,54,54,0.75' } : { color: '#ffcc66' }]">
        {{ modelInfo.alarmLevel }}位置 : {{ modelInfo.msgAddress }}
      </p>
      <p :style="[modelInfo.alarmLevel == '报警' ? { color: 'rgba(255,54,54,0.75' } : { color: '#ffcc66' }]">
        {{ modelInfo.alarmLevel }}内容 : {{ modelInfo.alarmIndex + modelInfo.alarmType }}
      </p>
      <p :style="[modelInfo.alarmLevel == '报警' ? { color: 'rgba(255,54,54,0.75' } : { color: '#ffcc66' }]">
        {{ modelInfo.alarmLevel }}次数 : {{ modelInfo.num }}
      </p>
      <p :style="[modelInfo.alarmLevel == '报警' ? { color: 'rgba(255,54,54,0.75' } : { color: '#ffcc66' }]">
        {{ modelInfo.alarmLevel }}时间 : {{ modelInfo.updateTime }}
      </p>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'BulletinBoard1',
  components: {},
  data () {
    return {
      dataList: [],
      modelInfo: [],
      speed: 50,
      colee: '',
      colee1: '',
      colee2: '',
      Title: '',
      visible: false,
      bodyStyle: {
        background: 'rgba(0, 0, 0, 0)'
      }
    }
  },
  created () { },
  mounted () {
    this.getKanbanData()
    // this.myScroll()
  },
  methods: {
    Rowclicklu () {
      this.$router.push({ path: '/alarm-list' })
    },
    showmodel (item) {
      this.Title = item.flowMeterNo
      this.modelInfo = item
      this.visible = true
    },
    handleCancel () {
      this.visible = false
    },
    getKanbanData () {
      const data = {
        sysTab: 5,
        isDispose: 0
      }
      this.$http.get('/pipe-network/remote_water_meter_alarm_messages/list', { params: data }).then((res) => {
        this.dataList = res.data
        if (this.dataList.length > 5) {
          this.$nextTick(() => {
            this.goScroll()
          })
        }
      })
    },
    goScroll () {
      const vm = this
      this.colee2 = document.getElementById('ulDiv2t')
      this.colee1 = document.getElementById('ulDivt')
      this.colee = document.getElementById('dataWarpt')
      this.colee2.innerHTML = this.colee1.innerHTML // 克隆colee1为colee2

      let MyMar1 = setInterval(this.Marquee1, this.speed) // 设置定时器
      // 鼠标移上时清除定时器达到滚动停止的目的

      this.colee.onmouseover = function () {
        clearInterval(MyMar1)
      }

      this.colee.onmouseout = function () {
        MyMar1 = setInterval(() => {
          vm.Marquee1()
        }, vm.speed)
      }

      this.$once('hook:beforeDestroy', () => {
        clearInterval(MyMar1)
        MyMar1 = null
      })
    },
    Marquee1 () {
      // 当滚动至colee1与colee2交界时
      if (this.colee2.offsetTop - this.colee.scrollTop <= 0) {
        this.colee.scrollTop -= this.colee1.offsetHeight + 20 // colee跳到最顶端
      } else {
        this.colee.scrollTop++
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 349px;
  width: 408px;
  background: url('/iconImg/backbox-bj.png') no-repeat;
  background-size: contain;
  position: relative;
  top: -40px;
  right: -20px;

  .img-title {
    position: absolute;
    position: relative;
    top: -20px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      width: 264px;
      height: 40px;
    }
  }

  .dataWarp {
    height: 210px;
    width: 388px;
    padding: 0 20px;
    overflow-x: hidden;

    .dataItem {
      width: 368px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      margin-top: 20px;

      .dataItemTitle {
        font-family: MicrosoftYaHeiSemibold;
        font-size: 15px;
        font-weight: 600;
        width: 200px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .dataItemTime {
        font-family: MicrosoftYaHei;
        font-size: 13px;
        color: rgba(11, 208, 245, 0.75);
        text-align: right;
        font-weight: 400;
      }
    }

    .dataItemNormal {
      background: url(~@/assets/myImg/content-box-06.png) no-repeat;
      background-size: cover;
    }

    .dataItemWarning {
      background: url(~@/assets/myImg/content-box-05.png) no-repeat;
      background-size: cover;
    }
  }
}

/deep/.ant-modal-content {
  background: url('/box-background@2x.png');
  background-size: 100% 100%;
  color: #00ebf0;
}

/deep/ .ant-modal-header {
  background: rgba(0, 0, 0, 0);
  border: none;
  border-bottom: 1px solid #00ebf0;
  margin: 0px 25px 0px 25px;
}

/deep/ .ant-modal-title {
  color: #00ebf0;
}

/deep/ .ant-modal-close-x {
  color: #00ebf0;
  margin-right: 10px;
  margin-top: 10px;
  display: none;
}

::-webkit-scrollbar {
  width: 0 !important;
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
